import React, { Fragment, useEffect, useState } from "react";
import InfoBox from "./InfoBox";
import { faBox, faUsers, faWarehouse, faDollarSign, faChartLine } from "@fortawesome/free-solid-svg-icons";
import util from "../../utils/miniUtils";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import './Dashboard.css';

export default function Dashboard() {

    const [data, setData] = useState( null );
    const [selectedLocation, setSelectedLocation] = useState( null );
    const [displayValue, setDisplayValue] = useState( 0 );

    useEffect( () => {
        getDashboardData().then( null );
    }, [] );

    useEffect( () => {
        if ( data && data.totalValueByLocation && data.totalValueByLocation.length > 0 ) {
            // Si no hay ubicación seleccionada, seleccionar la primera
            if ( selectedLocation === null ) {
                setSelectedLocation( data.totalValueByLocation[0].location_id );
            }
        }
    }, [data] );

    useEffect( () => {
        if ( data && data.totalValueByLocation && selectedLocation !== null ) {
            // Buscar el valor total de la ubicación seleccionada
            const locationData = data.totalValueByLocation.find( loc => loc.location_id === selectedLocation );
            if ( locationData ) {
                setDisplayValue( locationData.totalValue );
            }
        }
    }, [selectedLocation, data] );

    async function getDashboardData() {
        try {
            const request = await util.axios.get( `dashboard/totals` );
            let { error, msg, data } = request.data;
            if ( error ) throw msg;
            setData( data );
        } catch ( e ) {
            util.handleError( e );
        }
    }



    if ( data === null ) {
        return util.LOADING_SCREEN( true );
    }

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-container">
                {/* Fila 1: Tarjetas de totales */}
                <div className="dashboard-stats-row">
                    <div className="dashboard-stat-col">
                        <InfoBox icon={faBox} total={data.products} title="Productos" link="productos" />
                    </div>
                    <div className="dashboard-stat-col">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <InfoBox icon={faDollarSign} total={util.currencyFormat( displayValue )} title="Valor Total" />
                            {data.totalValueByLocation && data.totalValueByLocation.length > 1 && (
                                <select
                                    value={selectedLocation || ''}
                                    onChange={( e ) => setSelectedLocation( parseInt( e.target.value ) )}
                                    style={{
                                        padding: '0.5rem',
                                        borderRadius: '4px',
                                        border: '1px solid #ddd',
                                        fontSize: '0.9rem',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {data.totalValueByLocation.map( ( loc ) => (
                                        <option key={loc.location_id} value={loc.location_id}>
                                            {loc.locationName}
                                        </option>
                                    ) )}
                                </select>
                            )}
                        </div>
                    </div>
                    <div className="dashboard-stat-col">
                        <InfoBox icon={faWarehouse} total={data.totalLocations} title="Ubicaciones" />
                    </div>
                    <div className="dashboard-stat-col">
                        <InfoBox icon={faUsers} total={data.users} title="Usuarios" link="usuarios" />
                    </div>
                    <div className="dashboard-stat-col">
                        <InfoBox icon={faChartLine} total={data.categories} title="Categorías" />
                    </div>
                </div>

                {/* Fila 2: Tres tablas lado a lado */}
                <div className="dashboard-tables-row-three">
                    <div className="dashboard-table-col">
                        <TableOfResults
                            data={data.latestAdded}
                            title="Últimas 10 Altas"
                        />
                    </div>
                    <div className="dashboard-table-col">
                        <TableOfResults
                            data={data.latestRemoved}
                            title="Últimas 10 Bajas"
                        />
                    </div>
                    <div className="dashboard-table-col">
                        <TableOfResults
                            data={data.productsLast10}
                            title="Últimos 10 Modificados"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}


function TableOfResults( { title, data } ) {
    const getStockBadge = ( qty ) => {
        if ( qty === 0 ) return <span className="badge badge-danger">Sin stock</span>;
        if ( qty < 5 ) return <span className="badge badge-warning">Bajo</span>;
        return <span className="badge badge-success">OK</span>;
    };

    return (
        <Fragment>
            <div className="dashboard-table-header">
                <h4>{title}</h4>
            </div>
            <div className="dashboard-table-wrapper">
                <div className="dashboard-items-container">
                    {
                        data.map( ( p, i ) => {
                            return (
                                <div key={i} className="dashboard-item-card">
                                    <div className="item-row">
                                        <span className="item-label">Producto:</span>
                                        <span className="item-value">
                                            <span className="product-name">{p.article}</span>
                                            <span className="product-category">{p.categoryName}</span>
                                        </span>
                                    </div>
                                    <div className="item-row">
                                        <span className="item-label">Qty:</span>
                                        <span className="item-value">
                                            {p.qty === 0 ? getStockBadge( p.qty ) : p.qty}
                                        </span>
                                    </div>
                                    <div className="item-row">
                                        <span className="item-label">Precio:</span>
                                        <span className="item-value item-price">{util.currencyFormat( p.price )}</span>
                                    </div>
                                </div>
                            );
                        } )
                    }
                </div>
                <Table className="dashboard-table dashboard-table-desktop">
                    <Thead>
                        <Tr>
                            <Th className="col-num">#</Th>
                            <Th className="col-product">Producto</Th>
                            <Th className="col-qty">Qty</Th>
                            <Th className="col-price">Precio</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            data.map( ( p, i ) => {
                                return (
                                    <Tr key={i}>
                                        <Td className="col-num">{i + 1}</Td>
                                        <Td className="col-product">
                                            <div className="product-cell">
                                                <span className="product-name">{p.article}</span>
                                                <span className="product-category">{p.categoryName}</span>
                                            </div>
                                        </Td>
                                        <Td className="col-qty">
                                            <div className="qty-cell">
                                                {p.qty === 0 ? getStockBadge( p.qty ) : p.qty}
                                            </div>
                                        </Td>
                                        <Td className="col-price">{util.currencyFormat( p.price )}</Td>
                                    </Tr>
                                );
                            } )
                        }
                    </Tbody>
                </Table>
            </div>
        </Fragment>
    );
}
